import _get from 'lodash/get';
import _truncate from 'lodash/truncate';

export const Reject = (data) =>
  Promise.reject(_get(data, 'message', 'مشکلی در دریافت اطلاعات وجود دارد.!'));

export const parseArrName = (data = []) =>
  data.map((i) => ({
    value: i.id,
    label: i.name,
  }));

export const parseArrTitle = (data = []) =>
  data.map((i) => ({
    value: i.id,
    label: i.title,
  }));

export const toForm = (data) => {
  let formData = new FormData();
  for (let key in data) {
    if (data[key] != null) formData.append(key, data[key]);
  }

  return formData;
};

export const scrollToTop = () => {
  const container = document.querySelector('main.scrollbar-container');
  if (container)
    container.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
};

export const devMode = process.env.NODE_ENV === 'development';

export const Truncate = (str, length = 25, opt = {}) =>
  _truncate(str, { length, ...opt });

export const isValidIranianNationalCode = (input) => {
  if (!/^\d{10}$/.test(input)) return false;

  if (/^(\d)\1+$/.test(input)) return false;

  let check = +input[9];
  let sum =
    Array(9)
      .fill()
      .map((_, i) => +input[i] * (10 - i))
      .reduce((x, y) => x + y) % 11;
  return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
};

export const fPrice = (n = 0) => n.toLocaleString();
